import meta from '@mailobj-browser/front/js/selectors/meta.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import alert from '#utilities/js/ea/alert.js'
import globals from '#utilities/js/ea/globals.js'
import report from '#utilities/js/ea/report.js'
import * as devices from '#utilities/js/media/devices.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../../styles.js'
import done from './done.js'
import { ready } from './meet_rbw_ready.js'
import { meetProps, scopeProps, states, setState } from './props.js'
import stop from './stop.js'
import { ctrlButton, displayVideos } from './ui.js'
import { cnx } from './ws.js'

const postInit = () => {
  ready()
  const { dial } = meetProps()
  const { is_caller } = scopeProps()

  if (dial && is_caller) {
    const cbk2 = () => {
      rbwStartDial(dial)
    }
    cnx(cbk2)
  } else {
    cnx()
  }
}

export const rbwInit = async (token) => {
  if (token) {
    const { head } = document
    const { firstChild } = head
    let node = firstChild
    let found = false
    while (node) {
      if (node.tagName === 'SCRIPT') {
        if (node.src && node.src.indexOf('rainbow-ea') !== -1) {
          found = true
          break
        }
      }
      node = node.nextSibling
    }

    const { config, msgs } = scopeProps()
    if (!found) {
      const { images_root } = config
      const service = meta('ea_service')
      const urls = [
        '//code.jquery.com/jquery-2.1.3.min.js',
        '//cdn.jsdelivr.net/momentjs/2.15.1/moment-with-locales.min.js',
        '//cdnjs.cloudflare.com/ajax/libs/angular.js/1.7.5/angular.min.js',
        `${images_root}/${service}/common/rbw/vendors-sdk.min.js`]

      for (let i = 0; i < urls.length; i++) {
        await globals.ea_js_append_promise(urls[i])
      }

      await globals.ea_js_append_promise(
        `${images_root}/${service}/common/rbw/rainbow-ea.js`,
        1)
    }

    const prod = config.dev ? 0 : 1

    try {
      await globals.ea_rainbow_init(token, prod)
      postInit()
    } catch (e) {
      const detail = e.message || JSON.stringify(e)
      const message = 'rainbow init error: ' + detail
      report(new Error(message))
      done()
      await alert(`${msgs.err_call}`)
    }
  } else {
    postInit()
  }
}

export const rbwOnMessage = (event, tab) => {
  if (tab[0] === 'ready') {
    const { dial } = meetProps()
    const { is_caller } = scopeProps()
    if (dial && !is_caller)
      rbwJoinDial(dial)
  }
}

export const rbwOnNewAttendee = async (att) => {
  const { dial } = meetProps()
  const { config, is_caller, msgs } = scopeProps()
  const { video_domain } = config
  const { err_call } = msgs
  console.log('new attendee: ', att)

  if (dial) {
    console.log('in a web conf')
  } else if (is_caller) {
    queueMicrotask(() => {
      displayVideos()
    })
    try {
      const res = await
        globals.ea_rainbow_videocall(`${att.video}@${video_domain}`)
      console.log(res)
    } catch (e) {
      report(new Error('error on videocall: ' + JSON.stringify(e)))
      done()
      await alert(`${err_call}`)
    }
  } else {
    displayVideos()
  }
}

export const rbwCallStart = () => {
  globals.ea_elt_display_id('id_meet_accept', false, false)
  globals.ea_elt_display_id('minivideo', true, true)
  globals.ea_elt_display_id('largevideo', true, true)
  // globals.ea_elt_display_id('globalVideoTag', true, true)
  globals.ea_elt_display_id('globalAudioTag', true, true)
  globals.ea_elts_move_enable(one(`.${elements.meet}`))
  globals.ea_events_add('orientationchange', '.ea_generics__movable',
    (target, event) => {
      rbw_onorientationchange({ currentTarget: target })
    }, 1)
}

export const rbwCtrl = async () => {
  globals.ea_rainbow_ifvideodisabled(() => {
  })
  await globals.ea_rainbow_ifsharingdisabled(() => {
    const shareScreen = ctrlButton('shareScreen')
    const shareScreenOff = ctrlButton('shareScreenOff')

    shareScreen.classList.add(utilities.modifiers.display.none)
    shareScreenOff.classList.add(utilities.modifiers.display.none)
  })

  const switchCamera = ctrlButton('switchCam')
  if (globals.ea_rainbow_videonb() > 1) {
    switchCamera.classList.remove(utilities.modifiers.display.none)
  } else {
    switchCamera.classList.add(utilities.modifiers.display.none)
  }
}

export const rbwMute = (attendee) => {
  return globals.ea_rainbow_mute(attendee)
}
export const rbwUnmute = (attendee) => {
  return globals.ea_rainbow_unmute(attendee)
}
export const rbwMuteAll = () => {
  return globals.ea_rainbow_muteall()
}
export const rbwUnmuteAll = () => {
  return globals.ea_rainbow_unmuteall()
}

export const rbwStream = (mode, param) => {
  if (mode === 'camera') {
    globals.ea_rainbow_videoadd()
  } else if (mode === 'pause') {
    globals.ea_rainbow_videoremove()
  } else if (mode === 'screen') {
    queueMicrotask(async () => {
      try {
        if (param) {
          globals.ea_rainbow_sharingremove()
        } else {
          globals.ea_rainbow_sharingadd()
        }
      } catch (e) {
        report(new Error('Error on remove sharing'))
      }
    })
  }
}

export const rbwUiShareScreen = (endIt, sharer) => {
  const { dial } = meetProps()
  if (dial) {
    const meetConnect = one(`.${elements.meet_connect}`)
    const sharing = one(`.${elements.meet_sharing}`, meetConnect)
    const sharingDisplayParticipants = one(`.${elements.meet_sharing_display_participants}`, meetConnect)
    if (endIt) {
      const galleryCameras = one(`.${elements.meet_gallery_cameras}`, meetConnect)
      meetConnect.classList.remove(modifiers.meet_sharing.running)
      sharing.classList.add(utilities.modifiers.display.none)
      sharingDisplayParticipants.classList.add(utilities.modifiers.display.none)
      galleryCameras.classList.remove(utilities.modifiers.display.none)
    } else {
      meetConnect.classList.add(modifiers.meet_sharing.running)
      sharing.classList.remove(utilities.modifiers.display.none)
      sharingDisplayParticipants.classList.remove(utilities.modifiers.display.none)
    }
  }
}

const rbw_onorientationchange = (event) => {
  /* reset position on orientation change */
  const { currentTarget: elem } = event
  if (elem && elem.matches('.ea_generics__movable')) {
    let obj = event.currentTarget
    obj.style.left = ''
    obj.style.top = ''
  }
}

const rbwStartDial = async (dial) => {
  const { ws } = meetProps()
  let bubble = await globals.ea_rainbow_findbubble(dial.name)
  if (!bubble) {
    bubble = await globals.ea_rainbow_createbubble(dial.name, dial.attendees)
    console.debug('bubble created', bubble)
  } else {
    bubble = await globals.ea_rainbow_checkbubble(bubble, dial.attendees)
    console.debug('bubble updated', bubble)
  }
  if (globals.ea_rainbow_hasconf()) {
    console.debug('stopping previous conf')
    await globals.ea_rainbow_confstop()
  }
  try {
    const res = await globals.ea_rainbow_confcall(bubble, 1)
    setState(states.connect)
    ws.send('ready|' + globals.ea_boundary + '|')
  } catch (e) {
    const { st } = meetProps()
    if (st !== states.ended) {
      done()
      const { msgs } = scopeProps()
      report(new Error('error when initializing conf call: ' + JSON.stringify(e)))
      await alert(msgs.err_call)
    }
  }
}

const rbwJoinDial = async (dial) => {
  let bubble = await globals.ea_rainbow_findbubble(dial.name)
  if (!bubble)
    report(new Error('No bubble associated to this dial: ' + dial.name))
  else
    try {
      await globals.ea_rainbow_confcall(bubble)
    } catch (e) {
      const { st } = meetProps()
      if (st !== states.ended) {
        stop()
        const { msgs } = scopeProps()
        report(new Error('error when initializing conf call: ' + JSON.stringify(e)))
        await alert(msgs.err_call)
      }
      console.error(JSON.stringify(e))
    }
}

const merge = function(device) { /* use a PoF for 'this' */
  const { deviceId } = device
  const selected = deviceId === this
  return object(null, { device, selected })
}

export const rbwAllVideoInputDevices = async () => {
  const list = await devices.videoinput()
  const current = rbwCurrentVideoInputDevice()
  const { deviceId } = current
  return array(list.map(merge, deviceId))
}
export const rbwCurrentVideoInputDevice = () => {
  return globals.ea_rainbow_getcurrentvideoinputdevice()
}
export const rbwSetVideoInputDevice = (device) => {
  return globals.ea_rainbow_setvideoinputdevice(device)
}

export const rbwAllAudioInputDevices = async () => {
  const list = await devices.audioinput()
  const current = rbwCurrentAudioInputDevice()
  const { deviceId } = current
  return array(list.map(merge, deviceId))
}
export const rbwCurrentAudioInputDevice = () => {
  return globals.ea_rainbow_getcurrentaudioinputdevice()
}
export const rbwSetAudioInputDevice = (device) => {
  return globals.ea_rainbow_setaudioinputdevice(device)
}

export const rbwAllAudioOutputDevices = async () => {
  const list = await devices.audiooutput()
  const current = rbwCurrentAudioOutputDevice()
  const { deviceId } = current
  return array(list.map(merge, deviceId))
}
export const rbwCurrentAudioOutputDevice = () => {
  return globals.ea_rainbow_getcurrentaudiooutputdevice()
}
export const rbwSetAudioOutputDevice = (device) => {
  return globals.ea_rainbow_setaudiooutputdevice(device)
}

export const rbwAttachVideo = (id, videoSession) => {
  return globals.ea_rainbow_attachvideo(id, videoSession)
}

export const rbwDelegate = (attendee) => {
  return globals.ea_rainbow_delegate(attendee)
}

